module.exports = __webpack_public_path__ + "images/158_2048.jpg";